import {OtsBadge, OtsBadgeTone} from "../../components/OtsBadge";
import {StatusPill} from "../../components/StatusPill";
import {OtsTransportCategoryIcon} from "../../components/OtsTransportCategoryIcon";

export type ActivityPeriodHeaderBadgesProps = {
  type: string;
  status: string;
  category: string;
  density?: "compact" | "default";
};

const titleCaseCode = (value: string) => value
  .replace(/_/g, " ")
  .trim()
  .toLowerCase()
  .replace(/(^|\s)\S/g, character => character.toUpperCase());

export const getActivityPeriodTypeTone = (type: string): OtsBadgeTone => {
  switch (type.toUpperCase()) {
    case "DAILY": return "blue";
    case "WEEKLY": return "success";
    case "MONTHLY": return "warning";
    default: return "neutral";
  }
};

export const getActivityPeriodStatusTone = (status: string): OtsBadgeTone => {
  switch (status.replace(/_/g, " ").trim().toLowerCase()) {
    case "admin reviewed": return "yellow";
    case "vendor entered": return "danger";
    case "admin complete": return "blue";
    case "admin completed": return "blue";
    case "operator validated": return "violet";
    case "vendor approved": return "success";
    case "operator coded": return "indigo";
    default: return "neutral";
  }
};

/** Activity-period-specific mapping composed from reusable themed badges. */
export const ActivityPeriodHeaderBadges = ({
  type,
  status,
  category,
  density = "default",
}: ActivityPeriodHeaderBadgesProps) => {
  const size = density === "compact" ? "compact" : "default";
  const typeLabel = titleCaseCode(type);
  const statusLabel = titleCaseCode(status);
  const categoryLabel = titleCaseCode(category);

  return <div className="flex flex-wrap items-center gap-1.5" aria-label="Activity period attributes">
    <OtsBadge tone={getActivityPeriodTypeTone(type)} size={size} ariaLabel={`Activity period type: ${typeLabel}`} className="min-w-[62px] justify-center">
      {typeLabel}
    </OtsBadge>
    <StatusPill tone={getActivityPeriodStatusTone(status)} size={size} ariaLabel={`Activity period status: ${statusLabel}`}>
      {statusLabel}
    </StatusPill>
    <OtsBadge
      tone="neutral"
      size={size}
      ariaLabel={`Activity period category: ${categoryLabel}`}
      icon={<OtsTransportCategoryIcon category={category}/>}>
      {categoryLabel}
    </OtsBadge>
  </div>;
};
